function NewQuestion(defaultLanguageCode) {
    return {
        code: "newQuestionCode",
        groupQuestionId: null,
        id: null,
        inArchive: 0,
        introductoryText: "",
        isSys: 0,
        layoutType: 6,
        mediaUrl: null,
        openColumns: 40,
        openMax: 4000,
        openOptional: 0,
        openRows: 3,
        options: [],
        questionType: "SS",
        remarks: "",
        text: "",
		numericMin: null,
		numericMax: null,
		groupStatements: [],
		imageUrl: null,
		videoUrl: null,
        texts: [],
        defaultLanguageCode: defaultLanguageCode,
        folderId: null,
        isHidden: false,
        isCollapsibleIntro: false
      }
}
export default NewQuestion;

